// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__GwMaJ","control":"styles_control__VUfNz","indicator":"styles_indicator__k1Q_I","singleValue":"styles_singleValue__QcDnT","option":"styles_option__QyTGq"};